import React from 'react';
import { Phone, Clock, X, PhoneCall } from 'lucide-react';

export default function CallModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-md flex items-center justify-center z-[9999] p-4 animate-in fade-in duration-200">
      <div className="glass-modal max-w-sm w-full rounded-3xl p-6 text-center border border-white/80 shadow-2xl relative">
        <button onClick={onClose} className="absolute top-4 right-4 p-1 rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100/60 transition">
          <X className="w-5 h-5" />
        </button>

        <div className="w-14 h-14 bg-gradient-to-tr from-amber-400 to-orange-500 rounded-2xl flex items-center justify-center mx-auto mb-4 text-white shadow-lg shadow-orange-500/30">
          <PhoneCall className="w-7 h-7 animate-bounce" />
        </div>

        <h3 className="text-xl font-black text-slate-900 mb-1 tracking-tight">Call A1 Sims Support</h3>
        <p className="text-xs text-slate-500 mb-5">Our representative will assist you with new connections, porting, and instant activation.</p>

        <div className="bg-white/60 border border-slate-200/60 rounded-2xl p-4 mb-6">
          <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">Official Helpline</div>
          <div className="text-2xl font-black text-slate-900 tracking-tight">+91 92666 04406</div>
          <div className="flex items-center justify-center gap-1 text-[11px] text-emerald-600 font-bold mt-2">
            <Clock className="w-3.5 h-3.5" /> 10:00 AM – 8:00 PM (Daily)
          </div>
        </div>

        <div className="flex gap-2">
          <button onClick={onClose} className="flex-1 py-3 rounded-xl border border-slate-200 font-bold text-xs text-slate-600 hover:bg-slate-100/80 transition">
            Close
          </button>
          <a
            href="tel:+919266604406"
            className="flex-1 py-3 rounded-xl bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold text-xs shadow-md shadow-orange-500/20 flex items-center justify-center gap-1.5 transition"
          >
            <Phone className="w-4 h-4" /> Dial Now
          </a>
        </div>
      </div>
    </div>
  );
}